import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps, ColorTheme} from "../types";

export const PlaySquareIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const AthletaSVG = (isSmall = false): JSX.Element => {
    const bgColor = {fill: isLight ? "#fff" : "#111"};
    const playShapeColor = {fill: isLight ? "#111" : "#fff"};

    if (isSmall) {
      return (
        <svg fill="none" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H44V44H0V0Z" {...bgColor} fillOpacity="0.6" />
          <path
            d="M18.996 18V26.5771L25.244 22.2715L18.996 18Z"
            {...playShapeColor}
          />
        </svg>
      );
    }

    return (
      <svg fill="none" viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h61v61H0V0Z" {...bgColor} fillOpacity=".6" />
        <path d="M25.996 25v12l10-6.023-10-5.977Z" {...playShapeColor} />
      </svg>
    );
  };

  const OldNavySVG = (
    <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0h50v50H0z"
        fill={isLight ? theme.color.b1 : "#fff"}
        opacity=".75"
      />
      <path
        d="M30 25.5L21 32V19z"
        fill={isLight ? "#fff" : theme.color.b1}
        fillRule="evenodd"
      />
    </svg>
  );

  const brandIconLargeViewBoxSVGs = {
    [Brands.Athleta]: AthletaSVG(),
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: null,
    [Brands.GapFactoryStore]: null,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: null,
  };

  const brandIconSmallViewBoxSVGs = {
    ...brandIconLargeViewBoxSVGs,
    [Brands.Athleta]: AthletaSVG(true),
  };

  return (
    <ResponsiveIcon
      {...props}
      brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
      brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
      viewboxBreakpoint={props.brandName === Brands.Athleta ? 45 : 32}
    />
  );
};
